module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Accounts":"Accounts","Websites":"Webauftritte","Billing":"Abrechnung","Team":"Team","Provider costs":"Drittanbieterkosten","Platform":"Plattform"}}')
  delete Component.options._Ctor
}
